import {Directive, ElementRef, Input, OnInit, inject} from '@angular/core';
import {ApiService} from "../services/api.service";
import {TokenService} from "../services/token.service";

@Directive({
  selector: '[appVideoSrc]',
  standalone: true
})
export class VideoSrcDirective implements OnInit {
  private apiService: ApiService = inject(ApiService);
  private tokenService: TokenService = inject(TokenService);
  private el: ElementRef = inject(ElementRef);

  @Input() public fileName: string | undefined = undefined;

  public ngOnInit(): void {
    this.el.nativeElement.src = this.apiService.getUrl() + this.fileName + '?token=' + this.tokenService.getToken();
  }

}
